import { useEffect } from "react";

import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../../services/firebase";
import { config } from "../../config";
import { updatePushToken } from "../../utils/notifications";
import { useSelector } from "react-redux";

const PushNotification = () => {

    const { user } = useSelector((state) => state.user);


    useEffect(() => {
        const requestPermission = async () => {
            try {
                if (!user) return null;

                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                    const token = await getToken(messaging, { vapidKey: config.PUSH_NOTIFICATION_VAPID_KEY_PAIR_ID });

                    updatePushToken({ pushToken: token });

                }
            } catch (error) {
                console.error("Push notification error:", error);
            }
        };

        requestPermission();

        const unsubscribe = onMessage(messaging, (payload) => {
            new Notification(payload.notification.title, {
                body: payload.notification.body,
                icon: payload.notification.icon,
            });
        });

        return () => unsubscribe(); // Cleanup on unmount
    }, [user]);

    return null; // This component does not render UI
};

export default PushNotification;
